import { getSingleUser } from '@Actions/users';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CreateUserProvider } from '../../contexts/CreateUserContext';
import useNavigateTo from '../../hooks/useNavigateTo';
import UpdateUserPage from './UpdateUserPage';

export default function UpdateUserPageWithContext() {
	useNavigateTo();
	const dispatch = useDispatch();
	const { auth0Id } = useParams<{ auth0Id: string }>();

	useEffect(() => {
		dispatch(getSingleUser(auth0Id));
	}, [auth0Id]);

	return (
		<CreateUserProvider>
			<UpdateUserPage />
		</CreateUserProvider>
	);
}
